var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({height: _vm.height+'px',width: '100%'})},[_vm._v("1 "),_c('embed',{style:({height: _vm.height+'px',width: '100%'}),attrs:{"src":_vm.pdfurl,"type":"application/pdf"}})])}
var staticRenderFns = []

export { render, staticRenderFns }